<template>
  <div class="home">
    <!-- 头部 -->
    <div class="header">
      <div class="header-top">
        <div class="logo">
          <img src="/img/plogo.png" alt="" />
        </div>
        <div class="icon">
          <van-dropdown-menu>
          <van-dropdown-item title="历年数据"  @click.native="handleYear" v-model="zyear" :options="actions" />
        </van-dropdown-menu>
        </div>
      </div>
      <div class="banner"  v-if="active == 0 || active == 1">
       <div class="banner-main">
         <p class="p1"><span>{{zyear}}</span>年上海公务员考试</p>
         <p class="p2">职位查询系统</p>
       </div>
      </div>
      <van-sticky @change="stickychange">
          <van-tabs v-model="active" v-if="active == 0 || active == 1">
          <van-tab title="职位库">
          </van-tab>
          <van-tab title="分数库"></van-tab>
          <van-tab title="岗位排名">
          </van-tab>
        </van-tabs>
       <!-- 职位库 -->
        <div class="search" v-if="active == 0">
          <van-search
            v-model="form.major"
            show-action
            placeholder="请输入本科/研究生所学习专业"
          >
            <template #action>
              <div class="button" @click="onSearch">搜索</div>
            </template>
          </van-search>
           <van-dropdown-menu>
          <van-dropdown-item
            :title="title1"
            v-model="form.positionType"
            :options="positionType"
            @change="handleChange1"
             @click.native="handleChanges"
          />
          <van-dropdown-item
            :title="title2"
            v-model="form.specialtyExam"
            :options="specialtyExam"
            @change="handleChange2"
             @click.native="handleChanges"
          />
          <van-dropdown-item
            :title="title3"
            v-model="form.extArea"
            :options="extArea"
            @change="handleChange3"
            @click.native="handleChanges"
          />
          <van-dropdown-item title="更多" ref="item" @open="menuopen">
            <div class="father-more">
            <div class="more clearfix">
              <p>学历</p>
              <div class="main">
                <div
                  :class="{ active: current === -1 }"
                  class="button"
                  @click="handleEducation('', -1)"
                >
                  全部
                </div>
                <div
                  :class="{ active: current === index }"
                  class="button"
                  v-for="(item, index) in education"
                  :key="index"
                  @click="handleEducation(item, index)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="more clearfix">
              <p>学位</p>
              <div class="main">
                <div
                  class="button"
                  :class="{ active: current1 === -1 }"
                  @click="handleDegree('', -1)"
                >
                  全部
                </div>
                <div
                  class="button"
                  :class="{ active: current1 === index }"
                  @click="handleDegree(item, index)"
                  v-for="(item, index) in degree"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <div class="more clearfix">
              <p>政治面貌</p>
              <div class="main">
                <div
                  class="button"
                  :class="{ active: current2 === -1 }"
                  @click="handlePolitical('', -1)"
                >
                  全部
                </div>
                <div
                  :class="{ active: current2 === index }"
                  class="button"
                  v-for="(item, index) in political"
                  :key="index"
                  @click="handlePolitical(item, index)"
                >
                  {{ item }}
                </div>
              </div>
            </div>
			<div class="more clearfix">
			  <p>招考对象</p>
			  <div class="main">
			    <div
			      class="button"
			      :class="{ active: current3 === -1 }"
			      @click="handleTarget('', -1)"
			    >
			      全部
			    </div>
			    <div
			      :class="{ active: current3 === index }"
			      class="button"
			      v-for="(item, index) in jobtarget"
			      :key="index"
			      @click="handleTarget(item, index)"
			    >
			      {{ item }}
			    </div>
			  </div>
			</div>
            <div class="button-main" :style="'top:calc(80% + 0.8rem - '+topfix+'rem);'">
              <div class="button1" @click="handleReset">重置</div>
              <div class="button1" style="background-color: #2e94fe; color: #fff;" @click="handleSearch">确认</div>
            </div>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
        </div>
        <!-- 分数库 -->
         <div class="search" v-if="active == 1">
           <van-dropdown-menu>
          <van-dropdown-item
            :title="scoretitle1"
            v-model="form1.positionType"
            :options="positionType"
            @change="handleChange1Score"
             @click.native="handleChanges1"
          />
          <van-dropdown-item
            :title="scoretitle2"
            v-model="form1.specialtyExam"
            :options="specialtyExam"
            @change="handleChange2Score"
             @click.native="handleChanges1"
          />
          <van-dropdown-item
            :title="scoretitle3"
            v-model="form1.extArea"
            :options="extArea"
            @change="handleChange3Score"
            @click.native="handleChanges1"
          />
          <van-dropdown-item title="更多" ref="item1">
            <div class="father-more">
            <div class="more clearfix">
              <p>学历</p>
              <div class="main">
                <div
                  :class="{ active: scorecurrent === -1 }"
                  class="button"
                  @click="handleEducation1('', -1)"
                >
                  全部
                </div>
                <div
                  :class="{ active: scorecurrent === index }"
                  class="button"
                  v-for="(item, index) in education"
                  :key="index"
                  @click="handleEducation1(item, index)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="more clearfix">
              <p>学位</p>
              <div class="main">
                <div
                  class="button"
                  :class="{ active: scorecurrent1 === -1 }"
                  @click="handleDegree1('', -1)"
                >
                  全部
                </div>
                <div
                  class="button"
                  :class="{ active: scorecurrent1 === index }"
                  @click="handleDegree1(item, index)"
                  v-for="(item, index) in degree"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <div class="more clearfix">
              <p>政治面貌</p>
              <div class="main">
                <div
                  class="button"
                  :class="{ active: scorecurrent2 === -1 }"
                  @click="handlePolitical1('', -1)"
                >
                  全部
                </div>
                <div
                  :class="{ active: scorecurrent2 === index }"
                  class="button"
                  v-for="(item, index) in political"
                  :key="index"
                  @click="handlePolitical1(item, index)"
                >
                  {{ item }}
                </div>
              </div>
            </div>
			<div class="more clearfix">
			  <p>招考对象</p>
			  <div class="main">
			    <div
			      class="button"
			      :class="{ active: scorecurrent3 === -1 }"
			      @click="handleTarget1('', -1)"
			    >
			      全部
			    </div>
			    <div
			      :class="{ active: scorecurrent3 === index }"
			      class="button"
			      v-for="(item, index) in jobtarget"
			      :key="index"
			      @click="handleTarget1(item, index)"
			    >
			      {{ item }}
			    </div>
			  </div>
			</div>
            <div class="button-main" :style="'top:calc(80% + 0.8rem - '+topfix+'rem);'">
              <div class="button1" @click="handleReset1">重置</div>
              <div class="button1" style="background-color: #2e94fe; color: #fff;" @click="handleSearch1">确认</div>
            </div>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
        </div>
      </van-sticky>
      <!-- 职位库 -->
       <div v-if="active == 0" style="background: #f6f5f8; height: 100%">
           <div class="titleNumber">
        <p>
          为您找到相关职位<span style="color: #2595ff">{{ total }}</span
          >个
        </p>
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
		style="padding-bottom: env(safe-area-inset-bottom);"
      >
        <div
          class="positionDetails"
          v-for="(item, index) in tableData"
          :key="index"
          @click="handlePosition(item)"
        >
          <div class="position-top" style="display: flex">
            <div class="title van-ellipsis">
              <span>{{ item.positionName }}</span>
            </div>
            <div class="code">{{ item.positionCode }}</div>
          </div>
          <van-divider />
          <p>
            <span style="color: #888">用人单位：</span
            ><span>{{ item.units }}</span>
          </p>
          <p>
            <span style="color: #888">学历要求：</span
            ><span>{{ item.education }}</span>
          </p>
          <p>
            <span style="color: #888">招录人数：</span
            ><span>{{ item.numbers }}</span>
          </p>
          <p>
            <span style="color: #888">报考人数：</span
            ><span v-if="item.extSignUpCount == 0">-</span><span v-else>{{ item.extSignUpCount }}</span>
          </p>
          <van-button class="roundbutton" plain v-show="item.contrast" round type="info" size="mini" @click.stop="handleContrast(item)"><van-icon name="plus" />对比</van-button>
          <van-button class="roundbutton" v-show="!item.contrast" round type="info" size="mini" @click.stop="handleCancel(item)">取消</van-button>
        </div>
      </van-list>
        </div>
      <!-- 分数库 -->
       <div v-if="active == 1" style="background: #f6f5f8; height: 100%">
           <div class="titleNumber">
        <p>
          为您找到相关职位<span style="color: #2595ff">{{ total1 }}</span
          >个
        </p>
      </div>
      <van-list
        v-model="loading1"
        :finished="finished1"
        finished-text="没有更多了"
        @load="onLoad1"
		style="padding-bottom: env(safe-area-inset-bottom);"
      >
        <div
          class="positionDetails"
          v-for="(item, index) in tableData1"
          :key="index"
          @click="handlePosition(item)"
        >
          <div class="position-top" style="display: flex">
            <div class="title van-ellipsis">
              <span>{{ item.positionName }}</span>
            </div>
            <div class="code">{{ item.positionCode }}</div>
          </div>
          <van-divider />
          <p>
            <span style="color: #888">用人单位：</span
            ><span>{{ item.units }}</span>
          </p>
          <p>
            <span style="color: #888">招录人数：</span
            ><span>{{ item.numbers }}</span>
          </p>
           <p>
            <span style="color: #888">进面分数线：</span
            ><span>{{ item.extMinPaperScore }}</span>
          </p>
           <p>
            <span style="color: #888">最高分数线：</span
            ><span>{{ item.extMaxPaperScore }}</span>
          </p>
          <van-button class="roundbutton" plain v-show="item.contrast" round type="info" size="mini" @click.stop="handleContrast1(item)"><van-icon name="plus" />对比</van-button>
          <van-button class="roundbutton" v-show="!item.contrast" round type="info" size="mini" @click.stop="handleCancel1(item)">取消</van-button>
        </div>
      </van-list>
	  
        </div>
    </div>
    <PostRank v-if="active == 2"></PostRank>
    <Footer :joblist="jobList" @table-data="handleData"></Footer>
  </div>
</template>

<script>
import { api_position } from "@/common/Request.js";
import vanpopover from 'vant'
import PostRank from '@/components/postrank.vue'
import Footer from '@/components/footer.vue'
import { Toast } from 'vant';
export default {
  components: {
    vanpopover,
    PostRank,
    Footer
  },
  data() {
    return {
      extArea: [],
      positionType: [],
      specialtyExam: [],
      extEducationType: [
        { name: '大专', value: '1' },
        { name: '本科', value: '3' },
        { name: '硕士研究生', value: '5' },
        { name: '博士研究生', value: '6' }
      ],
	  education:[],
      degree: [],
      political: [],
	  jobtarget: [],
      // 职位库
      loading: true,
      finished: false,
      pageNo: 1,
      pageSize: 5,
      total: 0,
      current: -1,
      current1: -1,
      current2: -1,
	  current3: -1,
      form: {
        specialtyExam: "",
        positionType: "",
        extArea: "",
        extEducationType: "",
        degree: "",
        political: "",
        major: "",
		target: ""
      },
      // 分数库
      loading1: true,
      finished1: false,
      pageNo1: 1,
      pageSize1: 5,
      total1: 0,
       form1: {
        specialtyExam: "",
        positionType: "",
        extArea: "",
        // extEducationType: "",
		education:"",
        degree: "",
        political: "",
        major: "",
		target: "",
      },
      scorecurrent: -1,
      scorecurrent1: -1,
      scorecurrent2: -1,
	  scorecurrent3: -1,
      active: 0,
      title1: '考试类别',
      title2: '专业类别',
      title3: '地区',
      scoretitle1: '考试类别',
      scoretitle2: '专业类别',
      scoretitle3: '地区',
      tableData: [],
      tableData1: [],
      showPopover: false,
      zyear: 2025,
      show: false,
      show1:false,
      jobList: [],
      flag: false,
      actions: [{ text: "2025",value:"2025" },{ text: "2024",value: "2024" },{ text: "2023",value: '2023' },{ text: "2022",value:"2022" } ],
	  topfix: 0,
    };
  },
  created() {
    this.getlist();
    //this.positionDetailsList();
    //this.positionDetailsList1();
  },
  methods: {
    // 分数库职位库通用下拉数据
    getlist() {
      api_position.queryList({ zyear: this.zyear }).then((res) => {
        this.positionType = [];
        this.extArea = [];
        this.specialtyExam = [];
        res.data.extArea.forEach((item) => {
          this.extArea.push({ text: item, value: item });
        });
        this.extArea.unshift({ text: '全部',value: ''})
        res.data.positionType.forEach((item) => {
          this.positionType.push({ text: item, value: item });
        });
        this.positionType.unshift({text: '全部',value: ''})
        res.data.specialtyExam.forEach((item) => {
          this.specialtyExam.push({ text: item, value: item });
        });
        this.specialtyExam.unshift({text: '全部',value: '' })
        this.education = res.data.education;
        this.degree = res.data.degree;
        this.political = res.data.political;
		this.jobtarget=res.data.target;
		
		// if(this.$route.query.extEducationType){
		// 	console.log(this.$route.query.extEducationType);
			
		// 	let result = this.extEducationType.findIndex(v => (v.value == this.$route.query.extEducationType));
		// 	console.log('result', result);
		// 	this.handleEducation(this.extEducationType[result].value,result)		
		// }
		
		if(this.$route.query.political){
			console.log(this.$route.query.political);
			this.handlePolitical(this.$route.query.political,this.political.indexOf(this.$route.query.political))
		}
		
		if(this.$route.query.education){
			console.log(this.$route.query.education);
			this.handlePolitical(this.$route.query.education,this.education.indexOf(this.$route.query.education))
		}
		
		if(this.$route.query.target){
			console.log(this.$route.query.target);
			this.handleTarget(this.$route.query.target,this.jobtarget.indexOf(this.$route.query.target))
		}
		
		
		
		this.positionDetailsList()
		this.positionDetailsList1();
      });
    },
    // 职位库
    positionDetailsList() {
      this.form.major = this.form.major.replace(/\s*/g,"")
      const params = Object.assign({}, this.form, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        zyear: this.zyear,
      });
      api_position.possshList(params).then((res) => {
        if (res.data.records.length === 0) {
          this.tableData = [];
          this.finished = true;
        }
        res.data.records.forEach(item=>{
          item.contrast = true
              this.tableData.push(item)
        })
        this.total = res.data.total;
        this.loading = false;
        if (this.tableData.length >= res.data.total) {
          this.finished = true;
        }
      });
    },
    // 分数库
    positionDetailsList1() {
      const params = Object.assign({}, this.form1, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        zyear: this.zyear,
      });
      api_position.possshList(params).then((res) => {
        if (res.data.records.length === 0) {
          this.tableData1 = [];
          this.finished1 = true;
        }
        res.data.records.forEach(item=>{
          item.contrast = true
          this.tableData1.push(item)
        })
        this.total1 = res.data.total;
        this.loading1 = false;
        if (this.tableData1.length >= res.data.total) {
          this.finished1 = true;
        }
      });
    },
    handleYear() {
      if(this.deep()) {
         this.getlist();
         this.finished = false
         this.loading = true
         this.tableData = [];
         this.pageNo = 0;
         this.onLoad();
         this.finished1 = false
         this.loading1 = true
         this.tableData1 = [];
         this.pageNo1 = 0;
         this.onLoad1();
      }
    },
    // 职位库切换
    handleChange1Score(value) {
      if(this.deep()){
         this.scoretitle1 = value
      }
    },
     handleChange2Score(value) {
       if(this.deep()){
          this.scoretitle2 = value
       }
    },
     handleChange3Score(value) {
       if(this.deep()) {
         this.scoretitle3 = value
       }
    },
    handleChanges1 () {
      if(this.deep()) {
          this.finished1 = false
          this.loading1 = true
          this.tableData1 = [];
          this.pageNo1 = 0;
          this.onLoad1();
      }
    },
    // 分数库切换
    handleChange1(value) {
      if(this.deep()){
         this.title1 = value
      }
    },
     handleChange2(value) {
       if(this.deep()){
          this.title2 = value
       }
    },
     handleChange3(value) {
       if(this.deep()) {
         this.title3 = value
       }
    },
    handleChanges () {
      if(this.deep()) {
          this.finished = false
          this.loading = true
          this.tableData = [];
          this.pageNo = 0;
          this.onLoad();
      }
    },
    // 职位库对比
    handleContrast(item) {
      if(this.jobList.length > 3) {
        return Toast('最多只能选择4条对比');
      }
      this.jobList.push(item)
      item.contrast = !item.contrast
      this.show1 = true
    },
    handleCancel(item) {
       item.contrast = !item.contrast
       this.jobList =  this.jobList.filter(items=>{
            return items.id !== item.id
        })
       this.show1 = true
    },
    // 分数库对比
     handleContrast1(item) {
      if(this.jobList.length > 3) {
        return Toast('最多只能选择4条对比');
      }
      this.jobList.push(item)
      item.contrast = !item.contrast
      this.show1 = true
    },
    handleCancel1(item) {
       item.contrast = !item.contrast
       this.jobList =  this.jobList.filter(items=>{
            return items.id !== item.id
        })
       this.show1 = true
    },
    // 职位对比传参
    handleData(id) {
     this.tableData.forEach(item=>{
       if(item.id == id) {
         item.contrast = true
       }
     })
      this.jobList = this.jobList.filter(items=>{
            return items.id !== id
        })
    },
    // 职位库
    handleReset() {
      this.current = -1;
      this.current1 = -1;
      this.current2 = -1;
	  this.current3 = -1;
      this.form.extEducationType = "";
      this.form.degree = "";
      this.form.political = "";
	  this.form.target = "";
      this.finished = false
      this.loading = true
      this.tableData = [];
      this.pageNo = 0;
      this.onLoad();
      this.$refs.item.toggle();
    },
    handleEducation(item, index) {
      this.current = index;
      this.form.education = item;
    },
    handleDegree(item, index) {
      this.current1 = index;
      this.form.degree = item;
    },
    handlePolitical(item, index) {
      this.current2 = index;
      this.form.political = item;
    },
	handleTarget(item, index) {
	  this.current3 = index;
	  this.form.target = item;
	},
    onSearch() {
      if(this.deep()) {
          this.finished = false
          this.loading = true
          this.tableData = [];
          this.pageNo = 0;
          this.onLoad();
      }
    },
    handlePosition(item) {
      if(this.deep()) {
        this.$router.push({
            path: "/positiondetails",
            query: { code: item.positionCode,zyear: this.zyear },
          });
      }
    },
    handleSearch() {
      if(this.deep()) {
          this.finished = false
          this.loading = true
          this.tableData = [];
          this.pageNo = 0;
          this.onLoad();
          this.$refs.item.toggle();
      }
    },
    onLoad() {
      this.pageNo++;
      this.positionDetailsList();
    },
    // 分数库
     handleReset1() {
      this.scorecurrent = -1;
      this.scorecurrent1 = -1;
      this.scorecurrent2 = -1;
	  this.scorecurrent3 = -1;
      this.form1.education = "";
      this.form1.degree = "";
      this.form1.political = "";
	  this.form1.target = "";
      this.finished1 = false
      this.loading1 = true
      this.tableData1 = [];
      this.pageNo1 = 0;
      this.onLoad1();
      this.$refs.item1.toggle();
    },
    handleEducation1(item, index) {
      this.scorecurrent = index;
      this.form1.education = item;
    },
    handleDegree1(item, index) {
      this.scorecurrent1 = index;
      this.form1.degree = item;
    },
    handlePolitical1(item, index) {
      this.scorecurrent2 = index;
      this.form1.political = item;
    },
	handleTarget1(item, index) {
	  this.scorecurrent3 = index;
	  this.form1.target = item;
	},
    onSearch1() {
      if(this.deep()) {
          this.finished1 = false
          this.loading1 = true
          this.tableData1 = [];
          this.pageNo1 = 0;
          this.onLoad1();
      }
    },
    handleSearch1() {
      if(this.deep()) {
          this.finished1 = false
          this.loading1 = true
          this.tableData1 = [];
          this.pageNo1 = 0;
          this.onLoad1();
          this.$refs.item1.toggle();
      }
    },
    onLoad1() {
      this.pageNo1++;
      this.positionDetailsList1();
    },
	stickychange(fixflag){
		console.log(fixflag);
		if(fixflag){
			this.topfix=2.3;
		}
		else{
			this.topfix=0;
		}
		
	},
	menuopen(){
		//window.scrollTo(0,180);
	},
    // 判断用户是否登录
    deep() {
		
       if (this.$cookies.get("user_token")) {
		   console.log("read token");
        const newTime = Number(new Date());
        const token = this.$cookies.get("user_token");
        // const oldTime = token + 3600 * 1000 * 24 * 60;
        // if (newTime < oldTime) {
          this.flag = true
        //}
      }else {
        this.show = true;
      }
      return this.flag
    }
  },
};
</script>

<style lang="scss" scoped>
/*清除浮动*/
.clearfix:before,
.clearfix:after {
  content: '';
  display: table;
}
.clearfix:after {
  clear: both;
}
p {
  margin: 0;
}
.home {
  //width: 23.4375rem /* 750/32 */;
  .header {
    width: 100%;
    .header-top {
      background-color: #fff;
      // width: 23.4375rem /* 750/32 */;
      height: 3.15625rem /* 101/32 */;
      box-sizing: border-box;
      padding: 1.0625rem /* 34/32 */ 1.21875rem /* 39/32 */;
      .logo {
        float: left;
        img {
          width: 7.375rem /* 236/32 */;
          height: 1.4375rem /* 46/32 */;
        }
      }
      .title {
        margin-left: 1.3125rem /* 42/32 */;
        float: left;
        span {
          color: #333;
          font-size: .9375rem /* 30/32 */;
          font-family: PingFang SC;
          font-weight: bold;
          // height: 3.142857rem;
        }
      }
      .icon {
       width: 6.25rem /* 200/32 */;
      height: 1.5625rem /* 50/32 */;
        float: right;
       ::v-deep .van-dropdown-menu__bar {
         height: 1.25rem /* 40/32 */;
         box-shadow: 0 0 ;
       }
      }
    }
    .banner {
        //width: 23.4375rem /* 750/32 */;
        height: 7.8125rem /* 250/32 */;
        background-color: #fff;
        box-sizing: border-box;
        padding: 0px 0.9375rem;
      .banner-main {
        //width: 21.5625rem /* 690/32 */;
        height: 100%;
         background: url("/img/pbanner.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding-top: 2.34375rem /* 75/32 */;
        padding-left: .90625rem /* 29/32 */;
          box-sizing: border-box;
        .p1 {
          font-size: 1.125rem /* 36/32 */;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #FFFFFF;
        }
        .p2 {
           font-size: 1.75rem /* 56/32 */;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: #FFFFFF;
        }
      }
    
    }
    .search {
      // padding: 0.5rem 1rem 0.5rem 0.2rem;
      background-color: #fff;
      ::v-deep .van-search__action {
        width: 5rem /* 160/32 */;
        background: linear-gradient(0deg, #208dfe, #409eff);
        color: #fff;
        text-align: center;
      }
      ::v-deep .van-search--show-action {
        padding-right: .78125rem /* 25/32 */;
      }

      ::v-deep .van-search .van-cell {
        background-color: #f5f5f5;
      }
      ::v-deep .van-field__left-icon {
        display: none;
      }
    }
    .titleNumber {
      height: 2.3125rem /* 74/32 */;
      line-height: 2.3125rem /* 74/32 */;
      color: #999;
      p {
        margin-left: .90625rem /* 29/32 */;
        font-size: .75rem /* 24/32 */;
      }
    }
    .more {
      padding: 1.25rem /* 40/32 */  .9375rem /* 30/32 */;
      p {
        font-size: .9375rem /* 30/32 */;
        color: #333;
        font-weight: bold;
      }
      .main {
        margin-top: .9375rem /* 30/32 */;
      }
      .button {
		width: 10.46875rem /* 335/32 */;
        // width: 6.5625rem /* 210/32 */;
        height: 2.1875rem /* 70/32 */;
        font-size: .6875rem /* 22/32 */;
        font-weight: 500;
        color: #333;
        text-align: center;
        line-height: 2.1875rem /* 70/32 */;
        background-color: #f5f5f5;
        border-radius: .25rem /* 8/32 */;
        float: left;
        margin-right: .625rem /* 20/32 */;
        margin-bottom: .90625rem /* 29/32 */;
      }
      .button:nth-child(2n) {
        margin-right: 0px;
      }
      .active {
        background-color: #389aff;
        color: #fff;
      }
    }
    .more:nth-child(n + 2) {
      padding-top: 0px;
    }
    .button-main {
      text-align: center;
      width: 100%;
      padding: .625rem /* 20/32 */ .625rem /* 20/32 */;
      background-color: #fff;
      height: 2.1875rem /* 70/32 */;
      position: fixed;
	  padding-bottom:calc(env(safe-area-inset-bottom) + 0.8rem);
      .button1 {
       width: 6.5625rem /* 210/32 */;
       height: 2.1875rem /* 70/32 */;
       border: .03125rem /* 1/32 */ solid #999;
       line-height: 2.1875rem /* 70/32 */;
       text-align: center;
       float: left;
       margin-left: 3.25rem /* 40/32 */
      }
    }
    .positionDetails {
      position: relative;
      background-color: #fff;
      padding: .9375rem /* 30/32 */ .9375rem /* 30/32 */;
      box-sizing: border-box;
      margin-bottom: .625rem /* 20/32 */;
      .title {
        flex: 1;
        font-size: .875rem /* 28/32 */;
        color: #333;
      }
      .code {
        font-size: .75rem /* 24/32 */;
        width: 3.4375rem /* 110/32 */
      }
      p {
        margin-bottom: .3125rem /* 10/32 */;
        font-size: .8125rem /* 26/32 */;
      }
      .roundbutton {
        position: absolute;
        right: .9375rem;
        bottom: .9375rem;
      }
    }
	.father-more{
		padding-bottom:calc(constant(safe-area-inset-bottom) + 0.8rem);
		padding-bottom:calc(env(safe-area-inset-bottom) + 0.8rem);
	}
  }
}
</style>
